<template lang="pug">
.customer-payment-profile-list

  el-table(
    size="mini"
    v-loading="loading",
    :data="pagedPaymentProfiles",
    :row-class-name="rowClassName"
  )

    //- expand row with payment profile billing address and credit card information, if available, using el-descriptions
    el-table-column(type="expand")
      template(slot-scope="scope")
        .details

          el-descriptions(title="Perfil de pagamento", border, style="margin-bottom: 20px")
            el-descriptions-item(label="Status", :span="2")
              StatusTag(:active="scope.row.active")

          el-descriptions(v-if="scope.row.creditCard", title="Cartão de Crédito", border, style="margin-bottom: 20px")
            el-descriptions-item(label="Bandeira", :span="2") {{ scope.row.creditCard.brand }}
            el-descriptions-item(label="Número", :span="2") {{ scope.row.creditCard.displayNumber }}
            el-descriptions-item(label="Nome do Titular", :span="2") {{ scope.row.creditCard.holderName }}
            el-descriptions-item(label="Validade", :span="2")
              | {{ scope.row.creditCard.month.toString().padStart(2, '0') }}/{{ scope.row.creditCard.year }}

          el-descriptions(v-if="scope.row.billingAddress", title="Endereço de Cobrança", border)
            el-descriptions-item(label="CEP", :span="2") {{ scope.row.billingAddress.zipCode }}
            el-descriptions-item(label="Endereço", :span="2") {{ scope.row.billingAddress.street }}
            el-descriptions-item(label="Número", :span="2") {{ scope.row.billingAddress.number }}
            el-descriptions-item(label="Complemento", :span="2") {{ scope.row.billingAddress.complement }}
            el-descriptions-item(label="Cidade", :span="2") {{ scope.row.billingAddress.city }}
            el-descriptions-item(label="Bairro", :span="2") {{ scope.row.billingAddress.district }}
            el-descriptions-item(label="Estado", :span="2") {{ scope.row.billingAddress.state }}


    el-table-column(prop="id", label="ID", width="260")

    //- description
    el-table-column(label="Descrição", show-overflow-tooltip)
      template(slot-scope="scope")
        span {{ paymentProfileDescription(scope.row) }}

    el-table-column(label="Status", width="100")
      template(slot-scope="scope")
        StatusTag(:active="scope.row.active")

    //- createdAt
    el-table-column(prop="createdAt", label="Criado em", width="140")
      template(slot-scope="scope")
        span {{ toDate(scope.row.createdAt) }}

    //- updatedAt
    el-table-column(prop="updatedAt", label="Atualizado em", width="140")
      template(slot-scope="scope")
        span {{ toDate(scope.row.updatedAt) }}

  el-pagination.centralized(
    layout="prev, pager, next",
    hide-on-single-page,
    :total="paymentProfiles.length",
    :page-size="PAGE_SIZE",
    :current-page.sync="currentPage"
  )

</template>
<script setup>
import moment from 'moment'
import 'moment-timezone'

import { computed, ref, watch } from 'vue'
import VindiService from '@/services/billing/VindiService'
import StatusTag from '@/components/StatusTag.vue'

const BILLING_PLATFORM_ID = 2
const PAGE_SIZE = 12

const props = defineProps({
  customerId: {
    type: Number,
    required: true,
  },
});

const paymentProfiles = ref([]);
const loading = ref(false);
const currentPage = ref(1);

const pagedPaymentProfiles = computed(() => {
  const start = (currentPage.value - 1) * PAGE_SIZE
  return paymentProfiles.value.slice(start, start + PAGE_SIZE)
});

const fetchPaymentProfiles = async () => {
  loading.value = true

  try {
    paymentProfiles.value = await VindiService.findCustomerPaymentProfiles(BILLING_PLATFORM_ID, props.customerId)
    currentPage.value = 1
  } finally {
    loading.value = false
  }
}

watch(() => props.customerId, fetchPaymentProfiles, { immediate: true })

const rowClassName = ({ row }) => {
  return row.active === false ? 'inactive-row' : ''
}

const paymentProfileDescription = (paymentProfile) => {
  if (paymentProfile.type === 'CREDIT_CARD') {
    return `Cartão de Crédito - ${paymentProfile.creditCard.brand} - ${paymentProfile.creditCard.displayNumber}`;
  } else if (paymentProfile.type === 'BANK_SLIP') {
    return 'Boleto Bancário'
  } else if (paymentProfile.type === 'PIX') {
    return 'PIX'
  } else {
    return 'Tipo de pagamento desconhecido'
  }
}

const toDate = (dateString) => {
  return moment.utc(dateString, 'YYYY-MM-DDTHH:mm:ss').tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')
}
</script>
<style lang="sass">
.customer-payment-profile-list
  .details
    padding: 10px
  .inactive-row
    color: #C0C4CC
  .centralized
    margin-top: 10px
    text-align: center
</style>
